import { request } from './httpClient';

// ACON-60: read-only, account-scoped shipments (Core Release object). Distinct
// from `shipping.js`, which handles ship addresses/methods for checkout.
export function getShipments(params) {
  return request({ method: 'GET', url: '/v1/shipments', params });
}
